import { createActionGroup, props } from '@ngrx/store';
import { SessionsListResponse } from '../../../core/models/session-list.model';
import { SessionStatus } from '../../../core/models/session.model';

export const SessionsListActions = createActionGroup({
  source: 'Sessions List',
  events: {
    'Load Sessions': props<{ page: number; perPage: number; status?: SessionStatus }>(),
    'Load Sessions Success': props<{ response: SessionsListResponse }>(),
    'Load Sessions Failure': props<{ error: string }>(),
  },
});
